module.exports = __webpack_public_path__ + "static/media/favicon-polyu618.c121eec9.ico";